import React from "react";
import { NavLink } from "react-router-dom";

const TABS = [
  { id: "schedule", label: "Schedule", path: "/client-dashboard/shifts/schedule", end: true },
  {
    id: "timesheets",
    label: "Timesheets",
    path: "/client-dashboard/shifts/timesheets",
    end: true,
  },
];

const tabClassName = ({ isActive }) =>
  `text-xs tracking-wider uppercase px-0 pb-2 focus:outline-none ${
    isActive
      ? "border-b-2 border-buttonRed font-semibold text-foreground"
      : "text-muted-foreground hover:text-foreground"
  }`;

export default function ClientShiftsSubNav() {
  return (
    <nav
      className="flex justify-start gap-8 mb-3"
      aria-label="Shifts sections"
    >
      {TABS.map((tab) => (
        <NavLink
          key={tab.id}
          to={tab.path}
          end={tab.end}
          className={tabClassName}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
